// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusSquareFilledSvg from "@ant-design/icons-svg/es/asn/GooglePlusSquareFilled";
import AntdIcon from '../components/AntdIcon';

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilledSvg
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
export default React.forwardRef(GooglePlusSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GooglePlusSquareFilled.js
// module id = 1287
// module chunks = 0